import { Injectable, Pipe, PipeTransform } from "@angular/core";

@Injectable({
    "providedIn": "root"
  })
@Pipe({ 
        name: "orgStatus",
        standalone: true 
    })
export class OrgStatusPipe implements PipeTransform {
    transform (value: number): string {
        switch (value) {
            case 0:
                return "New";
            case 1:
                return "Active";
            case 2:
                return "Closed Out";
            case 3:
                return "Inactive";
            case 4:
                return "Deleted";
            default:
                return "";
        }
    }
}
